export { default } from './GridImage';
